import { css } from '@emotion/css';

export const carouselStyle = {
  width: '100%',
  aspectRatio: '16 / 9',
  overflow: 'hidden',
  borderRadius: '8px',
  position: 'relative' as const,
};

export const imageStyle = {
  width: '100%',
  height: '100%',
  objectFit: 'cover' as const,
  display: 'block' as const,
};

export const carouselContainerClass = css`
  .ant-carousel {
    height: 100%;

    .ant-carousel-content {
      height: 100%;
    }

    .slick-slide {
      height: 100%;

      & > div {
        height: 100%;
        position: relative;
        overflow: hidden;
      }
    }

    .slick-list {
      height: 100%;
    }

    .slick-track {
      height: 100%;
    }

    .ant-image {
      width: 100% !important;
      height: 100% !important;
      display: block !important;
      aspect-ratio: 16 / 9 !important;
      overflow: hidden !important;

      .ant-image-img {
        width: 100% !important;
        height: 100% !important;
        object-fit: cover !important;
        object-position: center !important;
        display: block !important;
      }

      .ant-image-placeholder {
        width: 100% !important;
        height: 100% !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        aspect-ratio: 16 / 9 !important;
      }
    }

    .ant-carousel-dots {
      bottom: 8px;

      li {
        button {
          background: rgba(255, 255, 255, 0.6);
          border-radius: 50%;
          width: 8px;
          height: 8px;
        }

        &.ant-carousel-dots-active button {
          background: white;
        }
      }
    }

    .slick-arrow {
      z-index: 10;
      width: 32px;
      height: 32px;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 50%;
      border: none;
      display: flex !important;
      align-items: center;
      justify-content: center;

      &.slick-prev:after {
        position: relative;
        padding: 0 !important;
        margin: 0 !important;
        line-height: 1 !important;
        top: 0;
      }

      &.slick-next:after {
        position: relative;
        padding: 0 !important;
        margin: 0 !important;
        line-height: 1 !important;
        top: 0;
        left: -2px;
      }

      &:hover {
        background: rgba(0, 0, 0, 0.6);
      }
    }

    .slick-dots {
      background: rgba(0, 0, 0, 0.3);
      border-radius: 12px;
      padding: 4px 4px;
      width: max-content;
      z-index: 5;
      margin: auto;
    }
  }

  &:hover .slick-arrow {
    opacity: 1 !important;
  }

  .slick-arrow {
    opacity: 0 !important;
    transition: opacity 0.2s ease-in-out !important;
  }

  @media (max-width: 768px) {
    .slick-arrow {
      opacity: 1 !important;
    }
  }
`;
